import React, { FC } from 'react'
import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'

import { useChat } from '../hooks/contexts/chat/ChatContext'

interface AlertEventTimeProps {
	readonly eventTime: string
}

const AlertEventTime: FC<AlertEventTimeProps> = ({
	eventTime,
}: AlertEventTimeProps) => {
	const { isChat } = useChat()

	const eventTimeSplitted = eventTime?.split(/([PA]M)/g)

	const eventTimeHours = eventTimeSplitted?.[0]
	const amOrPm = eventTimeSplitted?.[1]
	const eventDate = eventTimeSplitted?.[2]

	return (
		<Box
			sx={{ display: isChat ? 'flex' : 'block' }}
			className={'alert-event-time'}
		>
			{eventTimeHours && (
				<Typography>{`${eventTimeHours} ${amOrPm || ''}`}</Typography>
			)}
			{isChat && <Typography marginRight={2}>, </Typography>}

			{eventDate && <Typography>{eventDate}</Typography>}
		</Box>
	)
}

export default AlertEventTime
